import { IconButton } from "@mui/material";
import usePortfolio from "../hooks/PortfolioProvider";
import Dropdown, { ISelectRow } from "../libs/dropdown/Dropdown";
import _ from "lodash";
import { SettingsOutlined } from "@mui/icons-material";
import { useRef } from "react";
import { useDialog } from "../libs/dialog/DialogProvider";
import EditAccount from "../dialogs/Account/EditAccount";
import ManageAccounts from "../dialogs/Account/ManageAccounts";

export interface IAccountSelectProps {
    current:number;
    showAll:boolean;
    onSelect:(account:number) => void;
}
export default function AccountSelect(props:IAccountSelectProps) {
    const {portfolio} = usePortfolio()
    const ref = useRef<any>()
    const {openDialog} = useDialog()

    const options = portfolio.accounts.map(account => ({label:account.name,value:account.id,type:account.type}))
    options.sort((l,r) => l.type==r.type ? l.label.localeCompare(r.label) : l.type-r.type)
    if (props.showAll) options.unshift({value:-1,label:"Accounts",type:0})
    const onChange = (account:number|null) => props.onSelect(account!)
    const onSettings = (account:number) => (e:any) => {
        e.preventDefault()
        e.stopPropagation()
        ref.current?.close()
        openDialog({id:"editAccount", children:account>=0 ? <EditAccount account={account}/> : <ManageAccounts/>})
    }
    const accountRow = (account:ISelectRow<number>) => <div className="flex middle between gap-24 w-100 h-32">{account.label}<IconButton size="small" onClick={onSettings(account.value)}><SettingsOutlined/></IconButton></div>
    return <Dropdown ref={ref} options={options} value={props.current} onChange={onChange} rowRenderer={accountRow}/>
}